import { Overrides } from '@material-ui/core/styles/overrides';

export const initializeAccordionOverrides = (config?: Overrides['MuiAccordion']): Overrides['MuiAccordion'] => {
  return {
    root: {},
    ...config,
  };
};
